import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Rendered by the router whenever a route throws or a URL does not match. */
export function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isNotFound = isRouteErrorResponse(error) && error.status === 404;

  return (
    <Container maxWidth="sm">
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100dvh', textAlign: 'center' }}>
        <Stack spacing={2.5} alignItems="center">
          <Typography variant="overline" color="text.secondary">
            {isNotFound ? '404' : '500'}
          </Typography>
          <Typography variant="h3">
            {isNotFound ? t('common.notFoundTitle') : t('common.error')}
          </Typography>
          <Typography color="text.secondary">
            {isNotFound
              ? t('common.notFoundBody')
              : ((error as Error)?.message ?? t('common.error'))}
          </Typography>
          <Button variant="contained" size="large" onClick={() => navigate('/')}>
            {t('common.home')}
          </Button>
        </Stack>
      </Box>
    </Container>
  );
}
